
import React from 'react'

export default function About(props) {
    //const [myStyle, setMyStyle] = useState({
       // color:"white",
       // backgroundColor:"black" 
   // })
let myStyle={
  color:props.mode==='dark'?'white':'#042743',
  backgroundColor:props.mode==='dark'?'#042743':'white',
  
}

    /*const [btnText, setbtnText] = useState("enable dark mode")
     const hi=()=>{
   if(myStyle.color==="white"){
    setMyStyle({
        color:"black",
        backgroundColor:"white" 
    })
    setbtnText("enable dark mode")
   }
   else{
    setMyStyle({
        color:"white",
        backgroundColor:"black" 
    })
    setbtnText("enable white mode")
   }
   }*/
  return (
    <div className="cointainer" style={myStyle}>
        <h2 className='my-3'>About us</h2>
        <div className="accordion" id="accordionExample" style={myStyle}>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
         <strong>Accordion 1Item #</strong>
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={myStyle}>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. 
        Laborum delectus id quas eius adipisci sunt quaerat officia laboriosam illo dolore.
      </div>
    </div>
  </div>
  <div className="accordion-item" style={myStyle}>
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
       <strong>Accordion Item #2</strong> 
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={myStyle}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. 
        Sunt eius praesentium beatae ea repellat voluptatum repellendus reiciendis eaque, iure enim?
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed"style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
         <strong>Accordion Item #3</strong>
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={myStyle}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
         Cum necessitatibus quaerat doloremque reprehenderit id repudiandae assumenda ut voluptates corporis qui.
      </div>
    </div>
  </div>
</div>
{/*<div className="container my-3">
<button onClick={hi} type="button" className="btn btn-primary">{btnText}</button>
  </div>*/}
    </div>
  )
}
